import { Routes } from '@angular/router';
import { canDeactivateSupportPage } from './providers/can-deactivate-support.guard';
import { checkTutorialGuard } from './providers/check-tutorial.guard';
import { authGuard } from './gurds/auth-gurd';

export const routes: Routes = [

  // 🔁 Default redirect
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home').then(m => m.Home),
    canActivate: [ authGuard]
  },

  // 🔓 PUBLIC ROUTES
  
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/signup/signup').then(m => m.SignupPage),
    canActivate: [ authGuard]
  },
  {
    path: 'tutorial',
    loadComponent: () =>
      import('./pages/tutorial/tutorial').then(m => m.TutorialPage),
    canMatch: [checkTutorialGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgotpassword/forgotpassword')
        .then(m => m.ForgotpasswordPage),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/terms/terms').then(m => m.TermsPage),
  },
  {
    path: 'signin',
    loadComponent: () =>
      import('./pages/signup/signup').then(m => m.SignupPage),
   canActivate: [authGuard],
  },

  // 🔐 SECURED ROUTES
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home').then(m => m.Home),
    canActivate: [authGuard],
  },
  {
    path: 'agenthomePage',
    loadComponent: () =>
      import('./pages/agenthome/agenthome').then(m => m.AgenthomePage),
    canActivate: [authGuard],
  },
  {
    path: 'agentrequesttrackingPage',
    loadComponent: () =>
      import('./pages/agentrequesttracking/agentrequesttracking')
        .then(m => m.AgentrequesttrackingPage),
    canActivate: [authGuard],
  },
  {
    path: 'agentviewleads',
    loadComponent: () =>
      import('./pages/agentviewleads/agentviewleads')
        .then(m => m.AgentviewleadsPage),
    canActivate: [authGuard],
  },
  {
    path: 'agentuseradd',
    loadComponent: () =>
      import('./pages/agentuseradd/agentuseradd')
        .then(m => m.AgentuseraddPage),
    canActivate: [authGuard],
  },
  {
    path: 'agentdata',
    loadComponent: () =>
      import('./pages/agentdata/agentdata')
        .then(m => m.AgentdataPage),
    canActivate: [authGuard],
  },
  {
    path: 'schedule',
    loadComponent: () =>
      import('./pages/schedule/schedule')
        .then(m => m.SchedulePage),
    canActivate: [authGuard],
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./pages/support/support')
        .then(m => m.SupportPage),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateSupportPage],
  },
  {
    path: 'start-leads',
    loadComponent: () =>
      import('./pages/start-leads/start-leads')
        .then(m => m.StartLeadsPage),
    canActivate: [authGuard],
  },
  {
    path: 'leads',
    loadComponent: () =>
      import('./pages/leads/leads')
        .then(m => m.LeadsPage),
    canActivate: [authGuard],
  },
  {
    path: 'leads-view',
    loadComponent: () =>
      import('./pages/leads-view/leads-view')
        .then(m => m.LeadsViewPage),
    canActivate: [authGuard],
  },
  {
    path: 'rfq',
    loadComponent: () =>
      import('./pages/rfq/rfq')
        .then(m => m.RfqPage),
    canActivate: [authGuard],
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/aboutus/aboutus')
        .then(m => m.AboutusPage),
    canActivate: [authGuard],
  },
  {
    path: 'search',
    loadComponent: () =>
      import('./pages/search/search')
        .then(m => m.SearchPage),
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/profile/profile')
        .then(m => m.ProfilePage),
    canActivate: [authGuard],
  },
  {
    path: 'hscrm',
    loadComponent: () =>
      import('./pages/hscrm/hscrm')
        .then(m => m.HscrmPage),
    canActivate: [authGuard],
  },
  {
    path: 'favourites',
    loadComponent: () =>
      import('./pages/favourite/favourite')
        .then(m => m.FavouritePage),
    canActivate: [authGuard],
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./pages/notifications/notifications')
        .then(m => m.NotificationsPage),
    canActivate: [authGuard],
  },
  {
    path: 'franchise-request',
    loadComponent: () =>
      import('./pages/franchise-request/franchise-request')
        .then(m => m.FranchiseRequestPage),
    canActivate: [authGuard],
  },
  {
    path: 'agency-request',
    loadComponent: () =>
      import('./pages/agency-request/agency-request')
        .then(m => m.AgencyRequestPage),
    canActivate: [authGuard],
  },
  {
    path: 'buyers',
    loadComponent: () =>
      import('./pages/buyers/buyers')
        .then(m => m.BuyersPage),
    canActivate: [authGuard],
  },
  {
    path: 'buyerview',
    loadComponent: () =>
      import('./pages/buyerview/buyerview')
        .then(m => m.BuyerviewPage),
    canActivate: [authGuard],
  },
  {
    path: 'agent-profile',
    loadComponent: () =>
      import('./pages/agent-profile/agent-profile')
        .then(m => m.AgentProfilePage),
    canActivate: [authGuard],
  },
  {
    path: 'subscription',
    loadComponent: () =>
      import('./pages/subscription/subscription')
        .then(m => m.SubscriptionPage),
    canActivate: [authGuard],
  },
  {
    path: 'service-subscription',
    loadComponent: () =>
      import('./pages/servicesubscription/servicesubscription')
        .then(m => m.ServicesubscriptionPage),
    canActivate: [authGuard],
  },
  {
    path: 'maps',
    loadComponent: () =>
      import('./pages/maps/maps')
        .then(m => m.MapsPage),
    canActivate: [authGuard],
  },
  {
    path: 'videos',
    loadComponent: () =>
      import('./pages/video/video')
        .then(m => m.VideoPage),
    canActivate: [authGuard],
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./pages/contactus/contactus')
        .then(m => m.ContactusPage),
    canActivate: [authGuard],
  },
  {
    path: 'svr-toolkit',
    loadComponent: () =>
      import('./pages/toolkit/toolkit')
        .then(m => m.ToolkitPage),
    canActivate: [authGuard],
  },
  {
    path: 'download',
    loadComponent: () =>
      import('./pages/download/download')
        .then(m => m.DownloadPage),
    canActivate: [authGuard],
  },
  {
    path: 'social-media',
    loadComponent: () =>
      import('./pages/social-media/social-media')
        .then(m => m.SocialMediaPage),
    canActivate: [authGuard],
  },
  
  {
    path: 'post-leads',
    loadComponent: () =>
      import('./pages/agentpostleads/agentpostleads')
        .then(m => m.AgentpostleadsPage),
    canActivate: [authGuard],
  },
  {
    path: 'view-chapter',
    loadComponent: () =>
      import('./pages/view-chapter/view-chapter')
        .then(m => m.ViewChapterPage),
    canActivate: [authGuard],
  },
  {
    path: 'chapters',
    loadComponent: () =>
      import('./pages/chapters/chapters')
        .then(m => m.ChaptersPage),
    canActivate: [authGuard],
  },
  {
    path: 'leads-tabs',
    loadComponent: () =>
      import('./pages/leads-tabs/leads-tabs')
        .then(m => m.LeadsTabsPage),
    canActivate: [authGuard],
  },
  {
    path: 'chat-page',
    loadComponent: () =>
      import('./pages/chat-page/chat-page')
        .then(m => m.ChatPage),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login')
        .then(m => m.LoginPage),
    // canActivate: [authGuard],
  },
  {
    path: 'local-leads',
    loadComponent: () =>
      import('./pages/local-leads/local-leads')
        .then(m => m.LocalLeadsPage),
    canActivate: [authGuard],
  },
  {
    path: 'agent-pay',
    loadComponent: () =>
      import('./pages/agentpay/agentpay')
        .then(m => m.AgentpayPage),
    canActivate: [authGuard],
  },
  {
    path: 'agent-accounts',
    loadComponent: () =>
      import('./pages/agentaccounts/agentaccounts')
        .then(m => m.AgentaccountsPage),
    canActivate: [authGuard],
  },
  {
    path: 'agent-usercount',
    loadComponent: () =>
      import('./pages/agentusercounts/agentusercounts')
        .then(m => m.AgentusercountsPage),
    canActivate: [authGuard],
  },
  {
    path: 'pre-view',
    loadComponent: () =>
      import('./pages/pre-view/pre-view')
        .then(m => m.PreViewPage),
    canActivate: [authGuard],
  },
  {
    path: 'agentsubscription',
    loadComponent: () =>
      import('./pages/agentsubscription/agentsubscription')
        .then(m => m.AgentsubscriptionPage),
    canActivate: [authGuard],
  },



  // ❌ Wildcard fallback
  {
    path: '**',
    redirectTo: '/home',
  },
];
